import { locale } from '@harvesthq/clockwork'

import { Clock } from './hooks/useFetchCompany'
import { getWeekStartIndex } from './util'

export function initialiseClockwork(company) {
  locale.setLocale({
    decimal_separator: company.decimalSymbol,
    fiscal_year_start: 1, // TODO: Figure out if we should fetch that
    round_to: 0.1, // TODO: Figure out if we should fetch that
    rounding_style: 'none', // TODO: Figure out if we should fetch that
    thousands_separator: company.thousandsSeparator,
    time_format: company.timeFormat,
    wants_24h_time: company.clock === Clock._24H,
    week_start_day: getWeekStartIndex(company.weekStartDay),
  })

  return true
}
